import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const PublicBootstrapContext = createContext(null);
export function PublicBootstrapProvider({ value, children }) {
  const location = useLocation();
  const activeUrl = `${location.pathname}${location.search}`;
  const context = useMemo(() => value ? { ...value, activeUrl } : null, [value, activeUrl]);
  return <PublicBootstrapContext.Provider value={context}>{children}</PublicBootstrapContext.Provider>;
}
export function usePublicBootstrap() { return useContext(PublicBootstrapContext); }
// Route data belongs to one initial URL. It must never seed a different record
// after client navigation. Tenant context remains valid throughout that visit.
export function useInitialPublicData(key) {
  const bootstrap = usePublicBootstrap();
  return bootstrap?.url === bootstrap?.activeUrl ? bootstrap?.data?.[key] : undefined;
}
export function usePublicHostname() {
  const bootstrap = usePublicBootstrap();
  return bootstrap?.hostname || (typeof window !== 'undefined' ? window.location.hostname : '');
}
